import {
  jb_region_indicator_css_default
} from "./chunk.GNODAKQK.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  t
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-indicator/jb-region-indicator.ts
var JbRegionIndicator = class extends r {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      label: "Change your current location and language"
    };
  }
  firstUpdated() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent("region-indicator:clicked", { bubbles: true, composed: true }));
    });
    this.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.code === "Space") {
        e.preventDefault();
        e.target.click();
      }
    });
    this.requestUpdate();
  }
  render() {
    return ke`<div
      tabindex="0"
      role="list"
      aria-label="${this.ariaLabels?.label ?? this.ARIALABELS_DEFAULT.label}"
    >
      <slot></slot>
    </div>`;
  }
};
JbRegionIndicator.styles = jb_region_indicator_css_default;
__decorateClass([
  n({ type: Object })
], JbRegionIndicator.prototype, "ariaLabels", 2);
JbRegionIndicator = __decorateClass([
  t("jb-region-indicator")
], JbRegionIndicator);

export {
  JbRegionIndicator
};
